var text_field_default = {
  "root": "_0WZua",
  "text": "_1DegD",
  "input": "otMgL",
  "small": "hELKk",
  "medium": "Eyo9k",
  "large": "w4N1-",
  "webview": "V2Wmf",
  "endAdornment": "_6C80d",
  "shown": "_0-vK0",
  "value": "ZbtR8",
  "spinner": "_5PBAs",
  "spin": "BDEi5"
};
export {
  text_field_default as default
};
//# sourceMappingURL=text-field-scss.js.map
